export default __webpack_public_path__ + "static/media/d-6.14b2bcf6.png";